module.exports = __webpack_public_path__ + "static/media/d5kz.6426fab2.pdf";